import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

export const OLD_PASSWORD_RECOVERY = `${BASE_URL}/rest/v1.0/login/passwordRecovery/confirmation`;
export const EDIT_TWO_FA_SETUP = `${BASE_URL}/{username}/edit/twoFa`;
export const RESEND_TWO_FA_SETUP = `${BASE_URL}/{username}/modal/twoFACodeValidationServlet`;
